import moment from 'moment';

import type {AssignmentFilter, StudentAssignmentsFilters} from './StudentAssignment.types';

// The number of days before and after the current day that to-do assignments will be scoped to
export const TO_DO_PROXIMITY = 60;

export default function getFilters(
  classroomId: string | undefined,
  filter: AssignmentFilter,
  searchQuery?: string
): StudentAssignmentsFilters {
  const filters: StudentAssignmentsFilters = {
    hasStarted: {eq: true}
  };

  if (classroomId !== undefined) {
    filters.classrooms = {
      id: {eq: classroomId}
    };
  }

  if (filter === 'closed') {
    filters.isOpen = {eq: false};
  } else if (filter === 'open') {
    filters.isOpen = {eq: true};
  } else if (filter === 'toDo') {
    filters.dueDate = {
      greaterThanOrEqual: moment().subtract(TO_DO_PROXIMITY, 'days').startOf('day').format(),
      lessThanOrEqual: moment().add(TO_DO_PROXIMITY, 'days').endOf('day').format()
    };
    filters.hasSubmitted = {eq: false};
    filters.isOpen = {eq: true};
  }

  if (searchQuery) {
    filters.name = {ilike: `%${searchQuery}%`};
  }

  return filters;
}
